import React from 'react';
import Cell from './Cell.js';

export default function Board(props) {
  function handleClick(data) {
    props.handleClick(data);
  }

  let board = [];
  const data = props.data;
  let cellIndex = 0;
  data.map((cell, i) => {
    board.push(
      <Cell
        key={i}
        clickHandler={handleClick}
        data={cell}
        index={cellIndex++}
        hotCell={props.hotCell}
      ></Cell>
    );
  });

  return <div className="board">{board}</div>;
}
